<template>
  <div class="main-content">
    <van-nav-bar
      class="immersive-nav"
      id="titlebar"
      fixed
      placeholder
      title="打卡"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div style="flex: 1; width: 100%; height: 100%">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div class="scroll-content">
          <div class="user-content">
            <van-image
              width="45"
              height="45"
              radius="5"
              :src="
                common.currUserData?.avatar ||
                'https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg'
              "
            />
            <div
              style="
                flex: 1;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 5px;
                margin-left: 10px;
                box-sizing: border-box;
              "
            >
              <span style="font-size: 14px; color: #333333">{{
                common.currUserData?.userName ?? ""
              }}</span>
              <!-- <span style="font-size: 12px; color: #666666">未加入考勤组</span> -->
            </div>
          </div>
          <div class="clock-content">
            <div
              v-if="clockTimeList?.length > 0"
              style="
                width: 100%;
                height: 180px;
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
                column-gap: 5px;
              "
            >
              <div
                class="label-list"
                v-for="(item, position) in clockTimeList"
                :key="position"
              >
                <TimeLabelView
                  :title="`上班时间${item.startTime}`"
                  :time-label="`${item.clockInTime}已打卡`"
                  :type="item?.clockInTime?.length > 0 ? 2 : 1"
                  :is-show-badge="showBadge(item.type, 1)"
                  :is-show-update="showUpdate(item, 1)"
                  @click-update="handleUpdateClock(item, 1)"
                />
                <TimeLabelView
                  :title="`下班时间${item.endTime}`"
                  :time-label="`${item.clockOutTime}已打卡`"
                  :type="item?.clockOutTime?.length > 0 ? 2 : 1"
                  :is-show-badge="showBadge(item.type, 2)"
                  :is-show-update="showUpdate(item, 2)"
                  @click-update="handleUpdateClock(item, 2)"
                />
              </div>
            </div>
            <div class="buttons-content">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  height: 200px;
                  min-height: 200px;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div
                  :class="
                    !btnLoading && (clockStatus === 0 || !isEnableClock)
                      ? 'not-clock'
                      : 'button-clock'
                  "
                  @click="handleClickSign"
                >
                  <div v-if="btnLoading" class="rotating-wedge"></div>
                  <span
                    v-else
                    style="
                      font-size: 18px;
                      font-weight: 700;
                      font-family: 'HarmonyOS Sans Bold';
                      user-select: none;
                    "
                    >{{ clockBtnText }}</span
                  >
                  <span v-if="!btnLoading" style="user-select: none">{{
                    currTime
                  }}</span>
                </div>
                <span
                  v-if="
                    !btnLoading &&
                    locResult &&
                    clockStatus !== 0 &&
                    isEnableClock
                  "
                  style="
                    margin-top: 10px;
                    font-size: 14px;
                    color: #909399;
                    user-select: none;
                  "
                  >{{ `已进入考勤范围：${curClockInData?.address ?? ""}` }}
                </span>
                <span
                  v-if="!isEnableClock && !btnLoading && clockStatus !== 0"
                  style="
                    margin-top: 10px;
                    font-size: 14px;
                    color: #909399;
                    user-select: none;
                  "
                  >不在考勤范围，请下拉刷新，重新定位</span
                >
              </div>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
  <van-dialog
    v-model:show="showHintDg"
    close-on-click-overlay
    close-on-popstate
    title="打卡成功"
  >
    <template #title>
      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <van-icon name="checked" color="#67C23A" size="20" />
        <span style="font-size: 16px; margin-left: 10px">打卡成功</span>
      </div>
    </template>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        padding: 20px;
        box-sizing: border-box;
        color: #606266;
        font-size: 14px;
      "
    >
      <span>打卡时间：</span>
      <span style="margin-left: 5px">{{
        moment().format("yyyy-MM-DD  HH:mm")
      }}</span>
    </div>
  </van-dialog>
</template>

<script setup lang="ts">
import moment from "moment";
import TimeLabelView from "./components/TimeLabelView.vue";
import { userAuthStore } from "@/store/auth";
import AMapLoader from "@amap/amap-jsapi-loader";
import { debounce } from "lodash";
import {
  getAttendanceByDay,
  getSignkt,
  attendanceSign,
  attendanceUpdateSign,
} from "@/api/clockin";
import { showConfirmDialog, showToast } from "vant";

const common = userAuthStore();

// 打卡成功弹窗
const showHintDg = ref(false);
// 是否点击了打卡按钮，如果定位超过三分钟，则重新定位，定位成功，则执行打卡操作
const isClickSign = ref(false);

let timer: any = null;
const currTime = ref(moment().format("HH:mm:ss"));
// 定位返回结果
const locResult: any = ref(null);
// 当前考勤组数据（根据考勤状态接口判断）
const curClockInData: any = ref(null);
// 下拉刷新
const refreshing = ref(false);
const AMap: any = ref(null);
const onRefresh = async () => {
  await requestData();
  if (clockStatus.value !== 0) {
    // 如果定位插件未初始化，则初始化
    if (!AMap.value) {
      initLocation();
    }
    nextTick(() => {
      btnLoading.value = true;
      window?.DFlutter?.postMessage("reqLocation");
    });
  }
  refreshing.value = false;
};

// 标题栏返回
const onClickLeft = () => {
  window?.DFlutter?.postMessage("goBackToApp");
};

// 倒计时时间
const updateTimes = () => {
  const now = moment();
  currTime.value = now.format("HH:mm:ss");
};
// 自定义考勤状态，0 今天休息 1 上班打卡 2 下班打卡
const clockStatus = ref(1);
const showBadge = (curType, status) => {
  if (curClockInData.value) {
    if (
      curClockInData.value?.type === curType &&
      clockStatus.value === status
    ) {
      return true;
    }
  }
  return false;
};
// 是否允许更新打卡
const showUpdate = (item, status) => {
  // 已经打卡，并且当前打卡状态已变更，则可以更新打卡数据
  if (curClockInData.value) {
    // 上班卡更新打卡显示
    if (
      item?.type === curClockInData.value.type &&
      clockStatus.value === 2 &&
      status === 1 &&
      item?.clockInTime
    ) {
      return true;
    } else if (status === 2 && item?.clockOutTime) {
      if (
        curClockInData.value.type === "k2" &&
        clockStatus.value === 1 &&
        item?.type === "k1"
      ) {
        return true;
      } else if (
        curClockInData.value.type === "k3" &&
        clockStatus.value === 1 &&
        item?.type === "k2"
      ) {
        return true;
      } else if (
        curClockInData.value.type === "k3" &&
        clockStatus.value === 2 &&
        item?.type === "k3"
      ) {
        return true;
      }
    }
  }
  return false;
};
const btnLoading = ref(true);
// 是否允许打卡，true允许 false不允许
const isEnableClock = ref(true);
// 打卡按钮文字
const clockBtnText = computed(() => {
  if (clockStatus.value === 0) {
    return "今天休息";
  }
  if (!isEnableClock.value) {
    return "无法打卡";
  }
  if (clockStatus.value === 1) {
    return "上班打卡";
  }
  if (clockStatus.value === 2) {
    return "下班打卡";
  }
  return "今天休息";
});
// 当前考勤主键id
const currAttendanceId: any = ref("");
// 考勤打卡 上下班时间
const clockTimeList: any = ref([]);
const parseClockTime = (respon: any) => {
  clockTimeList.value = [];
  if (respon && respon?.k1?.t === "1") {
    // 表示第1组考勤可使用
    clockTimeList.value.push({
      type: "k1",
      startTime: respon?.k1.st1, // 计划上班时间
      endTime: respon?.k1.st2, // 计划下班时间
      clockInTime: respon?.k1.sts1, // 上班实际打卡时间（有值表示已打卡，为空"" 则表示未打卡）
      clockOutTime: respon?.k1.sts2, // 下班实际打卡时间
      address: respon?.k1.sd1,
      lat: respon?.k1.slat1,
      lon: respon?.k1.slon1,
      rang: respon?.k1.sr1,
    });
  }
  if (respon && respon?.k2?.t === "1") {
    // 表示第2组考勤可使用
    clockTimeList.value.push({
      type: "k2",
      startTime: respon?.k2.st1,
      endTime: respon?.k2.st2,
      address: respon?.k2.sd1,
      clockInTime: respon?.k2.sts1, // 上班实际打卡时间（有值表示已打卡，为空"" 则表示未打卡）
      clockOutTime: respon?.k2.sts2, // 下班实际打卡时间
      lat: respon?.k2.slat1,
      lon: respon?.k2.slon1,
      rang: respon?.k2.sr1,
    });
  }

  if (respon && respon?.k3?.t === "1") {
    // 表示第3组考勤可使用
    clockTimeList.value.push({
      type: "k3",
      startTime: respon?.k3.st1,
      endTime: respon?.k3.st2,
      address: respon?.k3.sd1,
      clockInTime: respon?.k3.sts1, // 上班实际打卡时间（有值表示已打卡，为空"" 则表示未打卡）
      clockOutTime: respon?.k3.sts2, // 下班实际打卡时间
      lat: respon?.k3.slat1,
      lon: respon?.k3.slon1,
      rang: respon?.k3.sr1,
    });
  }
};
// 处理打卡点击
const handleClickSign = debounce(() => {
  if (btnLoading.value || clockStatus.value === 0 || !isEnableClock.value) {
    return;
  }

  const nowTimes = Date.now();
  const lastTimes = Number.parseInt(localStorage.getItem("signTime") ?? "0");
  if (nowTimes - lastTimes >= 15 * 1000) {
    clickSign();
    localStorage.setItem("signTime", nowTimes.toString());
  } else {
    showToast("15秒内不能重复打卡");
  }
}, 300);

// 点击了更新打卡
const handleUpdateClock = async (item, type) => {
  const nowTime = moment();
  const locTime = locResult.value ? moment(locResult.value.callbackTime) : null;
  if (!locTime) {
    showToast("定位异常，请下拉刷新，重新定位");
    return;
  }
  const diffInMinutes = nowTime.diff(locTime, "minutes");
  if (diffInMinutes > 3) {
    showToast("定位异常，请下拉刷新，重新定位");
    return;
  }
  const message =
    type === 1
      ? `是否确认将上班打卡时间由[${item?.clockInTime}]更新为当前时间`
      : `是否确认将下班打卡时间由[${item?.clockOutTime}]更新为当前时间`;
  // 确认弹窗
  showConfirmDialog({
    title: "更新打卡",
    message: message,
  })
    .then(async () => {
      let distance = 0;
      if (locResult.value && curClockInData.value) {
        const locPoint: any = [
          locResult.value.longitude,
          locResult.value.latitude,
        ];
        const clockPoint: any = [
          curClockInData.value.lon,
          curClockInData.value.lat,
        ];
        distance = AMap.value?.GeometryUtil.distance(locPoint, clockPoint);
      }
      const params = {
        attendanceId: currAttendanceId.value,
        sts: moment().format("HH:mm"), // 打卡时间
        attendanceDay: moment().format("yyyyMMDD"),
        sds: locResult.value?.address,
        slats: locResult.value?.latitude,
        slons: locResult.value?.longitude,
        srs: distance,
        k: item.type,
        l: type,
      };
      await attendanceUpdateSign(params)
        .then(() => {
          showToast("更新打卡成功");
          requestData();
        })
        .catch((error) => {
          showFailToast("更新打卡失败");
          console.log("更新打卡失败...", error);
        });
    })
    .catch(() => {
      //
    });
};
// 考勤打卡
const clickSign = async () => {
  if (!isClickSign.value && btnLoading.value) {
    return;
  }
  // 0 休息 不打卡
  if (clockStatus.value === 0 || !isEnableClock.value) {
    return;
  }
  const nowTime = moment();
  const locTime = locResult.value ? moment(locResult.value.callbackTime) : null;
  if (!locTime) {
    showToast("定位异常，请下拉刷新，重新定位");
    return;
  }
  const diffInMinutes = nowTime.diff(locTime, "minutes");
  if (diffInMinutes > 3) {
    showToast("定位异常，请下拉刷新，重新定位");
    // btnLoading.value = true;
    // isClickSign.value = true;
    // await requestData();
    // if (clockStatus.value !== 0) {
    //   // 如果定位插件未初始化，则初始化
    //   if (!AMap.value) {
    //     initLocation();
    //   }
    //   nextTick(() => {
    //     btnLoading.value = true;
    //     window?.DFlutter?.postMessage("reqLocation");
    //   });
    // }
    return;
  }
  let distance = 0;
  if (locResult.value && curClockInData.value) {
    const locPoint: any = [locResult.value.longitude, locResult.value.latitude];
    const clockPoint: any = [
      curClockInData.value.lon,
      curClockInData.value.lat,
    ];
    distance = AMap.value?.GeometryUtil.distance(locPoint, clockPoint);
  }
  const params = {
    attendanceId: currAttendanceId.value, // 当前考勤主键id
    sts: moment().format("HH:mm"), // 打卡时间
    attendanceDay: moment().format("yyyyMMDD"),
    sds: locResult.value?.address,
    slats: locResult.value?.latitude,
    slons: locResult.value?.longitude,
    srs: distance,
  };
  btnLoading.value = true;
  await attendanceSign(params)
    .then(async () => {
      // 刷新页面数据
      await requestData();
      showHintDg.value = true;
    })
    .catch((error: any) => {
      btnLoading.value = false;
      showFailToast(error ?? "打卡失败");
    });
};
// 请求数据
const isRequestFinish = ref(true);
const requestData = async () => {
  isRequestFinish.value = false;
  const params = {
    websiteId: common.currUserData?.emplWebsiteId, //网点id
    empId: common.currUserData?.empId, // 员工id
    attendanceDay: moment().format("yyyyMMDD"), // 考勤日期
  };
  await getAttendanceByDay(params)
    .then((res: any) => {
      // 表示有打卡数据
      if (res && res?.dayJson?.t === "1") {
        currAttendanceId.value = res?.attendanceId;
        // 解析考勤打卡上下班时间
        parseClockTime(res?.dayJson);
        const obj = {
          attendanceId: currAttendanceId.value,
          sts: moment().format("HH:mm"),
          attendanceDay: moment().format("yyyyMMDD"),
        };
        return getSignkt(obj);
      }
      return Promise.reject("");
    })
    .then((res: any) => {
      // 考勤状态
      console.log("getSignkt", res);
      // 上班打卡
      if (res?.l === "1") {
        clockStatus.value = 1;
        // 下班打卡
      } else if (res?.l === "2") {
        clockStatus.value = 2;
      } else {
        // 休息
        clockStatus.value = 0;
      }
      if (res?.k === "k1") {
        const filter1 = clockTimeList.value?.filter(
          (item) => item.type === "k1"
        );
        if (filter1 && filter1.length > 0) {
          const [firstValue] = filter1;
          // 第一考勤组
          curClockInData.value = firstValue;
        }
      } else if (res?.k === "k2") {
        const filter2 = clockTimeList.value?.filter(
          (item) => item.type === "k2"
        );
        if (filter2 && filter2.length > 0) {
          const [firstValue] = filter2;
          // 第2考勤组
          curClockInData.value = firstValue;
        }
      } else if (res?.k === "k3") {
        const filter3 = clockTimeList.value?.filter(
          (item) => item.type === "k3"
        );
        if (filter3 && filter3.length > 0) {
          const [firstValue] = filter3;
          // 第3考勤组
          curClockInData.value = firstValue;
        }
      }
    })
    .catch((error: any) => {
      btnLoading.value = false;
      if (error?.statusCode === 506) {
        //  506 今天不需要考勤
        console.log("error", error);
        clockStatus.value = 0;
        showToast(error?.errorInfo ?? "今天休息");
      } else {
        clockStatus.value = 0;
        showFailToast(error ?? "考勤数据获取失败");
      }
    })
    .finally(() => {
      isRequestFinish.value = true;
      if (clockStatus.value !== 0) {
        nextTick(() => {
          window?.DFlutter?.postMessage("reqLocation");
        });
      }
      // setButtonEnabled();
    });

  // await getSignkt(obj)

  // .catch((error) => {
  //   clockStatus.value = 0;
  //   showFailToast(error ?? "考勤状态异常");
  // })
};

function setButtonEnabled() {
  console.log("currClock data :", JSON.stringify(curClockInData.value));
  console.log("web local result ", JSON.stringify(locResult.value));
  if (curClockInData.value && locResult.value && AMap.value) {
    const locPoint: any = [locResult.value.longitude, locResult.value.latitude];
    const clockPoint: any = [
      curClockInData.value.lon,
      curClockInData.value.lat,
    ];
    const distance = AMap.value?.GeometryUtil.distance(locPoint, clockPoint);
    const rangValue =
      common.platform && common.platform === "IOS"
        ? curClockInData.value?.rang
        : curClockInData.value?.rang * 3;
    if (distance && rangValue && distance > rangValue) {
      console.log(
        "setButtonEnabled local success 超出范围 ",
        JSON.stringify(curClockInData.value),
        distance
      );
      nextTick(() => {
        btnLoading.value = false;
        isEnableClock.value = false;
      });
    } else if (distance && rangValue && distance <= rangValue) {
      console.log(
        "setButtonEnabled local success 在范围内",
        JSON.stringify(curClockInData.value),
        distance
      );
      btnLoading.value = false;
      isEnableClock.value = true;
    }
    btnLoading.value = false;
  } else {
    console.log(
      "currClock data :",
      JSON.stringify(curClockInData.value),
      "web local result ",
      JSON.stringify(locResult.value)
    );
  }
}

function initLocation() {
  try {
    window.onLocationFail = function () {
      showFailToast("定位失败");
      btnLoading.value = false;
      locResult.value = null;
      isEnableClock.value = false;
      setButtonEnabled();
      console.log("定位失败");
    };
    window.onLocationSuccess = function (result) {
      if (result) {
        console.log("web 收到了定位返回结果: ", JSON.stringify(result));
        showSuccessToast("位置已更新");
        locResult.value = JSON.parse(result);
      } else {
        console.log("web 收到了定位返回结果是空的！！！！！！！！！！！ ");
      }
      setButtonEnabled();
    };
  } catch (error) {
    console.log("web 收到了定位返回结果发生了一个错误: ", error);
  }
}
onBeforeMount(() => {
  AMapLoader.load({
    key: "906f8d470a203d49a3f80477cb724614", // 申请好的Web端开发者Key，首次调用 load 时必填
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
  }).then((params) => {
    AMap.value = params;
    // const locPoint: any = [87.595392, 41.724193];
    // const clockPoint: any = [87.595392, 43.870508];
    // const distance = AMap.value?.GeometryUtil.distance(locPoint, clockPoint);
    // console.log("test  AMap.value ===", AMap.value);
    // console.log("test  distance ===", distance);
  });
});

onMounted(async () => {
  timer = setInterval(updateTimes, 1000); // 每秒更新一次时间
  btnLoading.value = true;
  await initLocation();
  await requestData();
});

onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
  }
});
</script>

<style scoped>
.main-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;
  font-size: 14px;
}
.scroll-content {
  width: 100%;
  height: calc(100vh - 96px);
  display: flex;
  margin-top: 46px;
  padding-bottom: 20px;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  box-sizing: border-box;
}

.user-content {
  width: 100%;
  height: 70px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}

.clock-content {
  width: 100%;
  height: 100%;
  flex: 1;
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.label-list {
  width: 100%;
  box-sizing: border-box;
  display: grid;
  box-sizing: border-box;
  margin-top: 5px;
  column-gap: 5px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
}
.buttons-content {
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-clock {
  display: flex;
  width: 130px;
  height: 130px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  background-color: #409eff;
  border-radius: 100px;
  color: #fff;
  box-shadow: 0px 0px 15px rgba(64, 158, 255, 0.8);
  gap: 5px;
}

.button-clock:active {
  background-color: #337ecc;
  transform: scale(0.95); /* 按下时缩小 */
}

.not-clock {
  display: flex;
  width: 130px;
  height: 130px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  border-radius: 100px;
  color: #fff;
  gap: 5px;
  background-color: #909399;
  box-shadow: 0px 0px 15px rgba(144, 147, 153, 0.8);
}

.rotating-wedge {
  position: absolute;
  width: 130px; /* 根据容器大小调整 */
  height: 130px; /* 根据容器大小调整 */
  /* background: conic-gradient(transparent, #ffffff1a); */
  background: conic-gradient(
    transparent 120deg,
    #ffffff66 270deg
  ); /* 创建0到10度的扇形渐变 */
  clip-path: polygon(50% 50%, 100% 0, 100% 100%, 50% 100%);
  transform-origin: 50% 50%; /* 旋转中心 */
  animation: rotate 2s linear infinite; /* 旋转动画 */
}

@keyframes rotate {
  from {
    transform: rotate(0deg); /* 从起始位置开始 */
  }
  to {
    transform: rotate(360deg); /* 旋转360度 */
  }
}
</style>
